import React from 'react';
import Shape from 'ati-ui-react/components/Shape';
import classnames from 'classnames';
import * as styles from './RatingRowMobile.scss';
import Icons from '../Icons';
import Recommendations from '../Recommendations';
import Claims from '../Claims';
import Firm from '../Firm';
import { openPassportPopup } from '../../utils';
import { makePassportRatingUrl } from '../../utils/urlProvider';
import RatingRowPosition from '../RatingRowPosition';

const RatingRowMobile = ({ row, selectedRow }) => {
  const {
    position,
    firm: {
      atiId,
    },
  } = row;
  const url = makePassportRatingUrl(atiId);
  const isSelected = position === selectedRow;

  return (
    <Shape
      shadow
      className={classnames(styles.row, { [styles.selected]: isSelected })}
      onClick={e => openPassportPopup(e, url)}
    >
      <RatingRowPosition position={row.position} />
      <div className={styles.ratingRowMobileContainer}>
        <Firm row={row} />
        <Icons row={row} />
        <Recommendations row={row} isMobile />
        <Claims row={row} />
      </div>
    </Shape>

  );
};

export default RatingRowMobile;
